// Safe base64 decoding that handles Unicode
export const base64ToArrayBuffer = base64 => {
  const binaryString = window.atob(base64.replace(/\s/g, ''))
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}
